export default __webpack_public_path__ + "static/media/instantbrands-logo.1514e4a9.svg";